import { Location, MarketplaceCategory } from '@eo-storefronts/eo-core'
import Title from '~/src/components/mui-wrappers/Title'

interface Props {
  location: Location,
}

const LocationCategories = ({ location }: Props) => {
  if (!location.categories?.length) {
    return null
  }

  return (
    <Title
      component='p'
      variant='body2'
      color='text.secondary'
      sx={{
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        pr: 0.5
      }}
    >
      {location.categories
        .map((category: MarketplaceCategory) => category.name)
        .join(' - ')}
    </Title>
  )
}

export default LocationCategories
